import { Box, Button } from "@mui/material";
import React from "react";
import { createTransactionRelation } from "../../../graphql/mutations";
import { API, graphqlOperation } from "aws-amplify";
import { showSuccessSnackbar } from "../../../components/snackBar/snakbar";

function SaveEntryTable({ data, editedItems,getInvoicesAndPayments  }) {
  async function saveChanges() {
    try {
      // items.map(async (ele) => {
      // if (Number(ele.linkedAmount )> 0) {
      //     let linkTransData = {
      //       LinkedAmount: Number(ele.linkedAmount),
      //       TransactionTypeCD: ele?.invoiceNumber?.transactionTypeCD,
      //       IsDirect: 0,
      //       ObjectAttribute: ele.invoiceNumber.label,
      //       ObjectID: ele.invoiceNumber.value,
      //       ObjectType: ele.paymentNumber?.transactionTypeCD,
      //       TransactionID: ele?.paymentNumber?.value,
      //       AccountID:data?.accountName?.value,
      //       PaymentVoucherNumber:ele?.paymentNumber?.label
      //     };

      //     const res = await API.graphql(
      //       graphqlOperation(createTransactionRelation, {
      //         createTransactionRelationInput: linkTransData,
      //       })
      //     );
      //   }
      // });
      let linkTransData = {
        LinkedAmount: Number(editedItems.linkedAmount),
        TransactionTypeCD: editedItems?.invoiceNumber?.transactionTypeCD,
        IsDirect: 0,
        ObjectAttribute: editedItems.invoiceNumber.vouchNo,
        ObjectID: editedItems.invoiceNumber.value,
        ObjectType: editedItems.paymentNumber?.transactionTypeCD,
        TransactionID: editedItems?.paymentNumber?.value,
        AccountID: data?.accountName?.value,
        PaymentVoucherNumber: editedItems?.paymentNumber?.vouchNo,
      };
      const res = await API.graphql(
        graphqlOperation(createTransactionRelation, {
          createTransactionRelationInput: linkTransData,
        })
      );
      getInvoicesAndPayments(data.accountName)
      showSuccessSnackbar("Success");
    } catch (error) {
      console.log("error", error);
    }
  }
  return (
    <Box
      sx={{
        borderRadius: "8px",
        marginBottom: "10px",
        boxShadow:
          "rgba(27, 31, 35, 0.04) 0px 1px 0px, rgba(255, 255, 255, 0.25) 0px 1px 0px inset",
        padding: { xs: "10px 0px", sm: "10px 10px" },
        borderRadius: "8px",
        ":hover": {
          boxShadow: "rgba(33, 35, 38, 0.1) 0px 10px 10px -10px",
        },
        transition: "all 1s ease-in-out",
        display: "flex",
        justifyContent: "flex-end", // Align items at the end
        alignItems: "flex-end",
      }}
    >
      <Button
        variant="contained"
        sx={{ marginRight: "8px" }}
        onClick={saveChanges}
      >
        LINK
      </Button>
      <Button variant="outlined">Cancel</Button>
    </Box>
  );
}

export default SaveEntryTable;
